export const CREDITS_TO_DOLLARS_RATIO = 4;

export const FREE_PLAN = {
    benefits: [
        "Up to 3 parallel environments",
        "Sandboxed Ona Environments with 4 cores, 16G RAM, 80GB disk",
        "Ona Agent with Opus 4.6",
        "Work from any device, including your phone",
    ],
} as const;
export const ENTERPRISE_PLAN = {
    benefits: [
        "VPC-deployment",
        "Complete network control",
        "Fine grained roles, permissions and policies (incl. MCP usage)",
        "Audit logs",
        "Uptime guarantees (SLAs)",
    ],
} as const;

const CORE_PLAN_MONTHLY_PRICE_USD = 20;

export const CORE_PLAN_AMOUNT_OPTIONS = [
    { amountUsd: 20, label: "80 OCUs" },
    { amountUsd: 50, label: "200 OCUs" },
    { amountUsd: 100, label: "400 OCUs" },
    { amountUsd: 200, label: "800 OCUs" },
    { amountUsd: 500, label: "2000 OCUs + 200 OCUs bonus" },
] as const;

export const CORE_PLAN = {
    monthlyPriceUsd: CORE_PLAN_MONTHLY_PRICE_USD,
    creditsPerMonth: CORE_PLAN_MONTHLY_PRICE_USD * CREDITS_TO_DOLLARS_RATIO,
    amountOptions: CORE_PLAN_AMOUNT_OPTIONS,
    benefits: [
        "Up to 100 team members",
        "Unlimited parallel environments",
        "Up to 32 cores, 128G RAM, 200G disk",
        "GPU Support",
        "Project sharing and collaboration",
    ],
} as const;
